import type { MessageDescriptor } from 'react-intl';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import type {
  DepositStatus,
  UserAccountEntryState,
} from '__generated__/globalTypes';
import { LabelS } from 'atoms/typography';

const EntryState = styled.div`
  padding: 0 var(--unit);
  border-radius: var(--quadruple-unit);
  color: var(--c-nd-600);
  &.pending {
    background-color: rgba(240, 206, 29, 0.25);
  }
  &.cancelled {
    background-color: var(--c-nd-100);
  }
  &.failed {
    background-color: rgba(var(--c-rgb-red-400), 0.25);
  }
`;

type Props = {
  state: UserAccountEntryState | DepositStatus;
  label: MessageDescriptor;
};

export const DumbAccountEntryState = ({ state, label }: Props) => {
  return (
    <EntryState className={state.toLowerCase()}>
      <LabelS>
        <FormattedMessage {...label} />
      </LabelS>
    </EntryState>
  );
};
